function checkIfCanalPlusUserIsTravelling() {
    const userPresentCountry =
        window?.dazn?.startupData?.Region?.GeolocatedCountry;
    const CanalPlusSupportedCountries = [
        'fr',
        're',
        'yt',
        'nc',
        'wf',
        'pf',
        'gf',
        'gp',
        'mq',
        'bl',
        'mf'
    ];
    return !CanalPlusSupportedCountries.includes(userPresentCountry);
}

export { checkIfCanalPlusUserIsTravelling };
